import type { ResponsiveProperty } from "@daangn/carotene/css";
import { handleResponsiveProp } from "@daangn/carotene/css";
import clsx from "clsx";

import type { AvatarSize } from "./avatar.css";
import { avatarBase, avatarSizeMedia } from "./avatar.css";

export type AvatarVariantProps = {
  size?: AvatarSize | ResponsiveProperty<AvatarSize>;
};

export function avatar({ size = 48 }: AvatarVariantProps) {
  return clsx(avatarBase, handleResponsiveProp(avatarSizeMedia, size));
}

export type AvatarGroupVariantProps = {
  size?: AvatarSize | ResponsiveProperty<AvatarSize>;
};
